import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_run_company_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_run_company_link.model';

export class StockLevelMonitoringRunCompanyLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_run_company_link: bl_inv_stock_level_monitoring_run_company_link_RowClass = new bl_inv_stock_level_monitoring_run_company_link_RowClass();
}
